import { gql } from '@apollo/client';

export const GET_TMS_SCHEDULE_LISTING = gql`
    query GetTmsScheduleListing($filter: TmsScheduleFiltersInput, $pageRequest: PageRequestTypeInput) {
        getTmsScheduleListing(filters: $filter, pageRequest: $pageRequest) {
            content {
                id
                scheduleName
                routeId
                warehouseId
                routeName
                routeType
                businessType
                planDepartureTime
                planDepartureTimezone
                planArrivalTime
                planArrivalTimezone
                arrivalDayOffset
                departureDayOffset
                departureFrequency
                carrierId
                carrierName
                carrierSourceType
                driverId
                driverName
                vehicleId
                vehicleNumber
                vehicleModelId
                vehicleModelName
                vehicleTypeId
                vehicleTypeName
                status
                createdAt
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export const GET_TMS_SCHEDULE_BY_ID = gql`
    query GetTmsScheduleById($id: ID!) {
        getTmsScheduleById(id: $id) {
            id
            scheduleName
            routeId
            warehouseId
            routeName
            routeType
            planDepartureTime
            planArrivalTime
            departureDayOffset
            departureFrequency
            carrierId
            carrierName
            carrierSourceType
            driverId
            driverName
            vehicleId
            vehicleNumber
            vehicleModelId
            vehicleModelName
            vehicleTypeId
            vehicleTypeName
            status
            createdAt
            updatedAt
        }
    }
`;

export const GET_TMS_SCHEDULE_WAYPOINTS_BY_SCHEDULE_ID = gql`
    query GetTmsScheduleWaypointsByScheduleId($scheduleId: Long!) {
        waypoints: getTmsScheduleWaypointsByScheduleId(scheduleId: $scheduleId) {
            id
            scheduleId
            waypointId
            waypointOrder
            waypointType
            waypointStatus
            travelTime
            dwellTime
            distance
        }
    }
`;

export const GET_TMS_SCHEDULES_FOR_SEARCH_SELECT = gql`
    query GetTmsSchedulesForSearchSelect($scheduleName: String, $warehouseId: Long, $routeType: Int) {
        getAllTmsSchedules(scheduleName: $scheduleName, warehouseId: $warehouseId, routeType: $routeType) {
            id
            scheduleName
        }
    }
`;

export const GET_TMS_SCHEDULES_BY_ROUTE_ID = gql`
    query GetTmsSchedulesByRouteId($routeId: Long!) {
        getTmsSchedulesByRouteId(routeId: $routeId) {
            id
            scheduleName
            routeId
            carrierId
            status
        }
    }
`;

export interface GetTmsSchedulesByRouteIdResponse {
    getTmsSchedulesByRouteId: TmsScheduleType[];
}

export interface TmsScheduleType {
    id: string;
    scheduleName: string;
    routeId: number;
    warehouseId: number;
    routeName?: string;
    routeType?: number;
    businessType?: number | null;
    planDepartureTime: string;
    planDepartureTimezone?: string;
    planArrivalTime: string;
    planArrivalTimezone?: string;
    arrivalDayOffset: number;
    departureDayOffset?: number;
    departureFrequency: string;
    carrierId: number;
    carrierName?: string;
    carrierSourceType?: number | null;
    driverId?: number;
    driverName?: string;
    vehicleId?: number;
    vehicleNumber?: string;
    vehicleModelId?: number;
    vehicleModelName?: string;
    vehicleTypeId?: number;
    vehicleTypeName?: string;
    status: string;
    createdAt: string;
    updatedAt: string;
}

export interface TmsScheduleFiltersInput {
    scheduleId?: number;
    routeId?: number;
    routeType?: number;
    carrierId?: number;
    warehouseId?: number;
    status?: number;
}

export interface TmsScheduleListingResponse {
    getTmsScheduleListing: TmsScheduleListingResponseType;
}

export interface TmsScheduleListingResponseType {
    content: TmsScheduleType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface TmsScheduleWaypointType {
    id: string;
    scheduleId: number;
    waypointId: number;
    waypointOrder: number;
    waypointType: number;
    waypointStatus: number;
    travelTime: number;
    dwellTime: number;
    distance: number;
}

export interface GetTmsScheduleByIdResponse {
    getTmsScheduleById: TmsScheduleType;
    waypoints?: TmsScheduleWaypointType[];
}

export interface GetTmsSchedulesForSearchSelectResponse {
    getAllTmsSchedules: Array<{
        id: string;
        scheduleName: string;
    }>;
}

